<template>
  <div class="search-bar">
    <form
      class="form"
      @submit.prevent
    >
      <div class="abs">
        <input
          v-model="searchText"
          type="text"
          class="search"
          placeholder="Search"
          @input="handleInputChange"
        >
        <div style="background-color: whitesmoke;">
          <v-icon
            v-if="searchText"
            title="Clear Search"
            class="x-close-btn"
            @click="clearSearch"
          >
            mdi-close
          </v-icon>
        </div>
        <div class="search-icon">
          <img
            :src="require('@/assets/svg/SVG/magglass.svg')"
            class="mag-glass"
          >
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useRMTStore } from '@/store/RMTStore';

export default {
  name: 'SearchBar',
  data () {
    return {
      searchText: ''
    };
  },
  mounted () {
    this.searchText = '';
    this.handleInputChange();
  },
  computed: {
    ...mapStores(useRMTStore),
  },
  methods: {
    handleInputChange () {
      const RMTStore = useRMTStore();
      RMTStore.setSearchText(this.searchText);
    },
    clearSearch () {
      this.searchText = '';
      this.handleInputChange();
    }
  },
};
</script>

<style scoped>
.search-bar {
  max-width: 740px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.form {
  width: 100%;
  margin-top: 15px;
  margin-bottom: 15px;
  font-size: .8em;
  border-radius: 18px 18px 18px 18px;
}
.search {

  flex: 1;
  height: 30px;
  padding: 15px;
  border-radius: 18px 0 0 18px;
  background-color: whitesmoke;
}
.search:focus {
  outline-width: 0;
}
.abs {
  display: flex;
}
.search-icon {
  cursor: pointer;
  width:35px;
  padding-right: 3px;
  height: 30px;
  background-color: whitesmoke;
  border-radius: 0 18px 18px 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.search-icon:hover {
  background-color: #e8e8e8;
  transition: background-color .2s;
}
.mag-glass {
  height: 14px;
}

.x-close-btn {
  width: 20px;
  background-color: whitesmoke;
  margin-top:6px;
}
</style>